// extracted by mini-css-extract-plugin
export default {"quiz_header":"Vy","quiz_header_wrapper":"Wy","header_button":"Xy","hidden":"Yy","gainful_logo":"Zy","MyClassEnterDone":"az","x_button":"bz","logoWrapper":"cz","logoWrapperMob":"ez"};
    if(module.hot) {
      // 1721922363932
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  